export default __webpack_public_path__ + "static/media/WSG.cabdafd8.svg";